import React, { ComponentProps } from 'react';
import { useInView } from 'react-hook-inview';

import { Link } from 'gatsby';

import PulsingOrb from '../../images/home/PulsingPropositionsOrb.json';
import { Section } from '../Section';
import { Button } from '../web';
import { LottieAnimation } from '../web/lottieAnimation';

const LottieProps: ComponentProps<typeof LottieAnimation>['desktopOptions'] = {
  loop: true,
  autoplay: false,
  animationData: PulsingOrb,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

type PlatformOverviewProps = {
  onClick?: () => void;
};

const PlatformOverview = (props: PlatformOverviewProps) => {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <Section bgClassName="tw-bg-parchment" className={classNames.container}>
      <div ref={ref} className={classNames.leftContainer}>
        <LottieAnimation
          inView={inView}
          mobileOptions={LottieProps}
          desktopOptions={LottieProps}
        />
      </div>
      <div className={classNames.rightContainer}>
        <h1 className={classNames.title}>
          Unlock data to make the best decisions for each IVF patient
        </h1>
        <h2 className={classNames.subtitle}>
          Alife Assist&trade; is a configurable platform designed to help each
          member of the clinic make more informed, data-based decisions. With
          seamless EMR integration, Alife&apos;s AI-powered software instantly
          converts raw data into actionable insights.
        </h2>
        <Link to="/platform">
          <Button
            className={classNames.button}
            preset="fab"
            text="See how it works"
            onClick={props.onClick}
          />
        </Link>
      </div>
    </Section>
  );
};

const classNames = {
  container: [
    'tw-flex',
    'tw-flex-col',
    'xl:tw-flex-row',
    'tw-gap-[48px]',
    'xl:tw-gap-[24px]',
  ].join(' '),
  leftContainer: ['tw-flex', 'xl:tw-flex-1', 'tw-justify-center'].join(' '),
  rightContainer: [
    'tw-flex',
    'xl:tw-flex-1',
    'tw-flex-col',
    'tw-gap-[24px]',
    'tw-text-center',
    'tw-items-center',
    'md:tw-items-start',
    'md:tw-text-start',
  ].join(' '),
  title: ['tw-display3'].join(' '),
  subtitle: ['tw-h3'].join(' '),
  button: ['md:tw-max-w-[297px]', 'tw-mt-[24px]'].join(' '),
};

export { PlatformOverview };
